import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { getSkin } from '../../../lib/skin';

const { GET } = api;

const OAUTH_RESOURCE_BASE_PATH = `${CONFIG.identityServiceBasePath}/oauth`;

export interface OAuthResource {
  logout: ResourceFetch<any>;
}

const OAuthResource: OAuthResource = {
  logout: GET(
    `${OAUTH_RESOURCE_BASE_PATH}/logout?client_id=${getSkin().getAuthParameters().clientId}`,
    {
      authenticated: false,
      withCredentials: true,
    },
  ),
};

export default OAuthResource;
